import * as React from 'react'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import VendorContactInfoCardMenu from 'vendors/components/vendorContact/VendorContactInfoCardMenu'
import { useGeneralContactReceivesRfps, useGeneralContactDoesNotReceiveRfps } from 'vendors/queries/useVendorQuery'
import { Navigate } from 'react-router'
import { useTranslation } from 'react-i18next'

type VendorGeneralContactCardProps = {
  onEdit: (generalContactId: string) => void
  onDelete: (contactId: string, contactEmail: string) => void
  contact: VendorContactType
  vendorId: string
}

const VendorGeneralContactCard: React.FC<VendorGeneralContactCardProps> = ({ onEdit, onDelete, contact, vendorId }) => {
  const { t } = useTranslation()

  const handleEditClick = () => {
    onEdit(contact.id)
  }

  const handleDeleteClick = () => {
    onDelete(contact.id, contact.email)
  }

  const { mutate: receivesRfps, isError: receivesRfpsError } = useGeneralContactReceivesRfps(vendorId, contact.id)

  const { mutate: doesNotReceiveRfps, isError: doesNotReceiveRfpsError } = useGeneralContactDoesNotReceiveRfps(
    vendorId,
    contact.id
  )

  const handleReceiveToggle = () => {
    if (contact.receiveRequestForProposals) {
      doesNotReceiveRfps()
    } else {
      receivesRfps()
    }
  }

  if (receivesRfpsError || doesNotReceiveRfpsError) {
    return <Navigate to="/error" replace />
  }

  return (
    <Card sx={{ width: '99%', maxWidth: 420, mx: 1 }}>
      <CardContent sx={{ backgroundColor: 'grey.200' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'fontWeightMedium' }}>{contact.email}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <VendorContactInfoCardMenu onEdit={handleEditClick} onDelete={handleDeleteClick} />
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ px: 2 }}>
        <FormControlLabel
          control={<Checkbox checked={contact.receiveRequestForProposals} onChange={handleReceiveToggle} />}
          label={t('will-receive-request-for-proposals')}
        />
      </CardActions>
    </Card>
  )
}

export default VendorGeneralContactCard
